export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [12,[2]],
		"/admin": [61,[11]],
		"/admin/evaluations": [62,[11]],
		"/admin/evaluations/[tab]": [63,[11]],
		"/admin/functions": [64,[11]],
		"/admin/functions/create": [65,[11]],
		"/admin/functions/edit": [66,[11]],
		"/admin/settings": [67,[11]],
		"/admin/settings/[tab]": [68,[11]],
		"/admin/users": [69,[11]],
		"/admin/users/[tab]": [70,[11]],
		"/auth": [71],
		"/auth/admin": [72],
		"/(app)/channels/[id]": [14,[2]],
		"/(app)/contact": [15,[2]],
		"/(app)/c/[id]": [13,[2]],
		"/(app)/document": [16,[2]],
		"/(app)/document/[id]": [17,[2]],
		"/error": [73],
		"/feature": [74],
		"/(app)/home": [18,[2,3]],
		"/(app)/image-chat": [19,[2]],
		"/(app)/image-chat/create": [20,[2]],
		"/(app)/notes": [21,[2,4]],
		"/(app)/notes/[id]": [22,[2,4]],
		"/notice": [75],
		"/notice/[id]": [76],
		"/(app)/page": [23,[2,5]],
		"/payment": [78],
		"/pay": [77],
		"/(app)/playground": [24,[2,6]],
		"/(app)/playground/completions": [25,[2,6]],
		"/policy/privacy": [79],
		"/(app)/project/[projectId]": [26,[2]],
		"/(app)/project/[projectId]/c/[id]": [27,[2]],
		"/(app)/slide": [28,[2]],
		"/(app)/slide/[id]": [29,[2]],
		"/s/[id]": [80],
		"/(app)/usage": [30,[2,7]],
		"/(app)/usage/date-summary": [31,[2,7]],
		"/(app)/usage/model-summary": [32,[2,7]],
		"/(app)/usage/summary": [33,[2,7]],
		"/(app)/usage/used": [34,[2,7]],
		"/(app)/video": [35,[2,8]],
		"/(app)/video/[id]": [36,[2,8]],
		"/watch": [81],
		"/(app)/workspace": [37,[2,9]],
		"/(app)/workspace/functions/create": [38,[2,9]],
		"/(app)/workspace/gpt": [39,[2,9,10]],
		"/(app)/workspace/gpt/create": [40,[2,9,10]],
		"/(app)/workspace/gpt/edit": [41,[2,9,10]],
		"/(app)/workspace/gpt/likelist": [42,[2,9,10]],
		"/(app)/workspace/gpt/mylist": [43,[2,9,10]],
		"/(app)/workspace/knowledge": [44,[2,9]],
		"/(app)/workspace/knowledge/create": [46,[2,9]],
		"/(app)/workspace/knowledge/[id]": [45,[2,9]],
		"/(app)/workspace/models": [47,[2,9]],
		"/(app)/workspace/models/create": [48,[2,9]],
		"/(app)/workspace/models/edit": [49,[2,9]],
		"/(app)/workspace/ocr": [50,[2,9]],
		"/(app)/workspace/prompts_back1": [54,[2,9]],
		"/(app)/workspace/prompts_back1/create": [56,[2,9]],
		"/(app)/workspace/prompts_back1/edit": [57,[2,9]],
		"/(app)/workspace/prompts_back1/[tab]": [55,[2,9]],
		"/(app)/workspace/prompts": [51,[2,9]],
		"/(app)/workspace/prompts/create": [52,[2,9]],
		"/(app)/workspace/prompts/edit": [53,[2,9]],
		"/(app)/workspace/tools": [58,[2,9]],
		"/(app)/workspace/tools/create": [59,[2,9]],
		"/(app)/workspace/tools/edit": [60,[2,9]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';